import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SchedulingView from '../views/SchedulingView.vue';
import ContactUsView from '../views/ContactUsView.vue';
import AboutUs from '../views/AboutUs.vue';
import BlogView from '../views/BlogView.vue';
import ImmigrationServices from '../views/ImmigrationServices.vue';
import BlogDetailView from '../views/BlogDetailView.vue';
import TestimonyView from '../views/TestimonyView.vue';
import TransactionSuccessView from '../views/TransactionSuccessView.vue';
import TransactionErrorView from '../views/TransactionErrorView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutUs,
    children: [
      {
      path: 'testimonies',
      component: TestimonyView
      }
  
    ],
  },
  {
    path: '/scheduling',
    name: 'scheduling',
    component: SchedulingView
  },
  {
    path: '/contact',
    name: 'contact-us',
    component: ContactUsView
  },
  {
    path: '/blog',
    name: 'blog',
    component: BlogView
  },
  {
    path: '/services',
    name: 'services',
    component: ImmigrationServices
  },
  {
    path: '/view-blog/:postId',
    name: 'view-blog',
    component: BlogDetailView
  },
  {
    path: '/transaction/success',
    name: 'transaction-success',
    component: TransactionSuccessView
  },
  {
    path: '/transaction/error',
    name: 'transaction-error',
    component: TransactionErrorView
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

export default router
